import { useBalanceWithPoints } from "@apac/components/checkout";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ENABLE_FLIGHT_FX_DISCLAIMER } from "@hsbc/utilities";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const BalanceToPayLineItem = ({
  fiatFormatOptions,
}: {
  fiatFormatOptions?: Intl.NumberFormatOptions;
}) => {
  const { t, formatFiatCurrency } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "BalanceToPayLineItem");

  const { remainingBalance } = useBalanceWithPoints();
  const remainingBalanceToPay = formatFiatCurrency(
    remainingBalance,
    fiatFormatOptions
  );

  return (
    <div className={clsx(block, { [cn("show")]: remainingBalance?.value > 0 })}>
      <div className={cn("summary-item-label")}>
        {t("rewards.priceBreakdown.balanceToPay")}
        {ENABLE_FLIGHT_FX_DISCLAIMER && (
          <div className={cn("fx-disclaimer")}>
            {t("breakdown.fxRateDisclaimer")}
          </div>
        )}
      </div>

      <div className={cn("summary-item-value")}>{remainingBalanceToPay}</div>
    </div>
  );
};
